'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import cn from 'classnames';
import { type ReactNode } from 'react';
import { Backdrop } from '../backdrop';
import { Body } from './body';
import { Footer } from './footer';
import { Header } from './header';
import './side-drawer.scss';
type Side = 'left' | 'right';
type SideDrawerProps = {
  children: ReactNode;
  initialFocus?: Dialog.Popup.Props['initialFocus'];
  isOpen: boolean;
  onOpenChange: NonNullable<Dialog.Root.Props['onOpenChange']>;
  onOpenChangeComplete?: Dialog.Root.Props['onOpenChangeComplete'];
  className?: string;
  onClose?: () => void;
  onOpen?: () => void;
  showBackdrop?: boolean;
  side?: Side;
};
function SideDrawerRoot(t0) {
  const $ = _c(24);
  const {
    children,
    initialFocus,
    isOpen,
    onOpenChange,
    onOpenChangeComplete,
    className,
    onClose,
    onOpen,
    showBackdrop: t1,
    side: t2
  } = t0;
  const showBackdrop = t1 === undefined ? true : t1;
  const side = t2 === undefined ? "left" : t2;
  let t3;
  if ($[0] !== onClose || $[1] !== onOpen || $[2] !== onOpenChange) {
    t3 = (isOpening, eventDetails) => {
      isOpening ? onOpen?.() : onClose?.();
      onOpenChange(isOpening, eventDetails);
    };
    $[0] = onClose;
    $[1] = onOpen;
    $[2] = onOpenChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleOpenChange = t3;
  let t4;
  if ($[4] !== showBackdrop) {
    t4 = showBackdrop && <Dialog.Backdrop render={<Backdrop className="side-drawer__backdrop" />} />;
    $[4] = showBackdrop;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== className) {
    t5 = cn("side-drawer", className);
    $[6] = className;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== initialFocus || $[10] !== side || $[11] !== t5) {
    t6 = <Dialog.Popup className={t5} data-side={side} initialFocus={initialFocus}>{children}</Dialog.Popup>;
    $[8] = children;
    $[9] = initialFocus;
    $[10] = side;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== side || $[14] !== t6) {
    t7 = <Dialog.Viewport className="side-drawer__viewport" data-side={side}>{t6}</Dialog.Viewport>;
    $[13] = side;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <Dialog.Portal>{t4}{t7}</Dialog.Portal>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== handleOpenChange || $[20] !== isOpen || $[21] !== onOpenChangeComplete || $[22] !== t8) {
    t9 = <Dialog.Root open={isOpen} onOpenChange={handleOpenChange} onOpenChangeComplete={onOpenChangeComplete}>{t8}</Dialog.Root>;
    $[19] = handleOpenChange;
    $[20] = isOpen;
    $[21] = onOpenChangeComplete;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export const SideDrawer = Object.assign(SideDrawerRoot, {
  Body,
  Description: Dialog.Description,
  // For screen readers
  Footer,
  Header,
  Title: Dialog.Title // For screen readers
});